import { insightsReportsWizardSlice } from './insightsReportsWizardSlice';

export const { resetInsightsReportsWizardState } = insightsReportsWizardSlice.actions;
